export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/08ee3b32e72dd5b2b700754671ea2016.svg";